import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { 
    getSzakfelelosBySzakkod, 
    getAdvisoryBoardByKepzes, 
    getBelsoVelemenyezokLista,
    getBelsoVelemenyezokByKepzes,
    addBelsoVelemenye,
    removeBelsoVelemenye
} from "../apis/SzakokFinder"; // API hívás a szakkód alapján
import { UserContext } from '../context/UserContext';
import "../routes/AlapadatokView.css";

const SzakInformacio = () => {
    const { szakkod: rawSzakkod } = useParams(); // A szakkód lekérése a paraméterekből
    const szakkod = decodeURIComponent(rawSzakkod); // Decode URL-encoded szakkod
    console.log("🔍 SzakInformacio - Raw szakkod:", rawSzakkod);
    console.log("🔍 SzakInformacio - Decoded szakkod:", szakkod);
    const { userData } = useContext(UserContext);
    const [alapadatok, setAlapadatok] = useState(null);
    const [advisoryBoard, setAdvisoryBoard] = useState([]); // Advisory board tagok
    const [advisoryBoardLoading, setAdvisoryBoardLoading] = useState(false);
    const [belsoVelemenyezokLista, setBelsoVelemenyezokLista] = useState([]); 
    const [assignedBelsoVelemenyezok, setAssignedBelsoVelemenyezok] = useState([]); 
    const [belsoVelemenyezokLoading, setBelsoVelemenyezokLoading] = useState(false);
    const [showReviewerModal, setShowReviewerModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [showRemoveModal, setShowRemoveModal] = useState(false);
    const [reviewerToRemove, setReviewerToRemove] = useState(null);
    const [isLoading, setIsLoading] = useState(true);  // Betöltés állapot
    const [error, setError] = useState(null);  // Hiba állapot

    const filteredReviewers = belsoVelemenyezokLista
        .filter(reviewer => !assignedBelsoVelemenyezok.some(assigned => assigned.nk === reviewer.nk))
        .filter(reviewer => 
            searchTerm === '' || 
            reviewer.nev.toLowerCase().includes(searchTerm.toLowerCase())
        );

    useEffect(() => {
        console.log("SzakInformacio loaded with szakkod:", szakkod);  // Log a szakkódra
        const fetchAlapadatok = async () => {
            try {
                setIsLoading(true);  // Betöltés megkezdése
                console.log("🔍 Fetching data for szakkod:", szakkod);
                const alapadatokResponse = await getSzakfelelosBySzakkod(szakkod);
                console.log("📦 Full API response:", alapadatokResponse);
                console.log("📦 Response.data:", alapadatokResponse.data);
                console.log("📦 Response type:", typeof alapadatokResponse);
                console.log("📦 Response keys:", Object.keys(alapadatokResponse));
                
                setAlapadatok(alapadatokResponse.data);  // Beállítjuk az adatokat
                console.log("✅ Alapadatok set to:", alapadatokResponse.data);
                
                if (alapadatokResponse.data && alapadatokResponse.data.kepzes_neve && alapadatokResponse.data.kepzesi_szint) {
                    console.log("🔍 Fetching advisory board for:", {
                        kepzes_neve: alapadatokResponse.data.kepzes_neve,
                        kepzesi_szint: alapadatokResponse.data.kepzesi_szint
                    });
                    
                    setAdvisoryBoardLoading(true);
                    try {
                        const advisoryBoardResponse = await getAdvisoryBoardByKepzes(
                            alapadatokResponse.data.kepzes_neve,
                            alapadatokResponse.data.kepzesi_szint
                        );
                        console.log("📋 Advisory board response:", advisoryBoardResponse.data);
                        setAdvisoryBoard(advisoryBoardResponse.data.data || []);
                        
                        setBelsoVelemenyezokLoading(true);
                        const belsoVelemenyezokResponse = await getBelsoVelemenyezokByKepzes(
                            alapadatokResponse.data.kepzes_neve,
                            alapadatokResponse.data.kepzesi_szint
                        );
                        console.log("📋 Internal reviewers response:", belsoVelemenyezokResponse.data);
                        setAssignedBelsoVelemenyezok(belsoVelemenyezokResponse.data.data || []);
                    } catch (advisoryError) {
                        console.error("❌ Failed to fetch advisory board:", advisoryError);
                        setAdvisoryBoard([]);
                        setAssignedBelsoVelemenyezok([]);
                    } finally {
                        setAdvisoryBoardLoading(false);
                        setBelsoVelemenyezokLoading(false);
                    }
                } else {
                    console.log("⚠️ Missing kepzes_neve or kepzesi_szint in alapadatok:", alapadatokResponse.data);
                }
            } catch (error) {
                console.error("Failed to fetch alapadatok:", error);  // Log az API hívás során fellépő hibára
                setError("Nem sikerült lekérni az adatokat.");
            } finally {
                setIsLoading(false);  // Betöltés befejezése
            }
        };

        fetchAlapadatok();
    }, [szakkod]);

    const fetchAvailableReviewers = async () => {
        try {
            const response = await getBelsoVelemenyezokLista();
            setBelsoVelemenyezokLista(response.data.data || []);
        } catch (error) {
            console.error("Failed to fetch available reviewers:", error);
        }
    };

    const handleAddReviewer = async (reviewer) => {
        try {
            await addBelsoVelemenye(
                reviewer.nk,
                alapadatok.kepzes_neve,
                alapadatok.kepzesi_szint,
                userData?.name || "Ismeretlen felhasználó"
            );
            
            const response = await getBelsoVelemenyezokByKepzes(
                alapadatok.kepzes_neve,
                alapadatok.kepzesi_szint
            );
            setAssignedBelsoVelemenyezok(response.data.data || []);
            setShowReviewerModal(false);
            
        } catch (error) {
            console.error("Failed to add reviewer:", error);
            alert("Hiba történt a véleményező hozzáadásakor.");
        }
    };

    const handleRemoveReviewer = (reviewer) => {
        setReviewerToRemove(reviewer);
        setShowRemoveModal(true);
    };

    const confirmRemoveReviewer = async () => {
        if (!reviewerToRemove) return;

        try {
            await removeBelsoVelemenye(
                reviewerToRemove.nk,
                alapadatok.kepzes_neve,
                alapadatok.kepzesi_szint
            );
            
            const response = await getBelsoVelemenyezokByKepzes(
                alapadatok.kepzes_neve,
                alapadatok.kepzesi_szint
            );
            setAssignedBelsoVelemenyezok(response.data.data || []);
            
            setShowRemoveModal(false);
            setReviewerToRemove(null);
            
        } catch (error) {
            console.error("Failed to remove reviewer:", error);
            alert("Hiba történt a véleményező eltávolításakor.");
            setShowRemoveModal(false);
            setReviewerToRemove(null);
        }
    };

    const handleShowAddReviewerModal = async () => {
        await fetchAvailableReviewers();
        setSearchTerm(''); 
        setShowReviewerModal(true);
    };
    

    return (
        <div className="alapadatok-view uj-szak-page szakinfo-page">
            <div className="uj-szak-container szakinfo-container">
                <h1>Szak alapadatok</h1>
                {isLoading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p>{error}</p>
                ) : (
                    // Az adatmegjelenítés mindig megtörténik, ha van adat
                    <div className="szakinfo-data">
                        <div><strong>Képzés neve:</strong> <span>{alapadatok.kepzes_neve}</span></div>
                        <div><strong>Képzési szint:</strong> <span>{alapadatok.kepzesi_szint}</span></div>
                        <div><strong>Képzési terület:</strong> <span>{alapadatok.kepzesi_terulet}</span></div>
                        <div><strong>Kreditszám:</strong> <span>{alapadatok.kreditszam}</span></div>
                        <div><strong>Munkarend:</strong> <span>{alapadatok.munkarend && alapadatok.munkarend.join(", ")}</span></div>
                        <div><strong>Képzési forma:</strong> <span>{alapadatok.kepzesi_forma}</span></div>
                        <div><strong>Specializációk:</strong> <span>{alapadatok.specializaciok && alapadatok.specializaciok.join(", ")}</span></div>
                        <div><strong>Engedélyszám:</strong> <span>{alapadatok.engedelyszam}</span></div>
                        <div><strong>Szak indításának első tanéve:</strong> <span>{alapadatok.szak_inditas && alapadatok.szak_inditas.join(", ")}</span></div>
                        <div><strong>Képzést gondozó kar:</strong> <span>{alapadatok.kepzest_gondozo_kar}</span></div>
                        <div><strong>Képzést gondozó tanszék:</strong> <span>{alapadatok.kepzest_gondozo_tanszek}</span></div>
                        <div><strong>Szakfelelős neve:</strong> <span>{alapadatok.szakfelelos_neve}</span></div>
                    </div>
                )}
            </div>
            
            {!isLoading && !error && alapadatok && (
                <div className="uj-szak-container szakinfo-container-spaced">
                    <h1 className="section-header">Advisory board</h1>
                    {advisoryBoardLoading ? (
                        <p>Advisory board adatainak betöltése...</p>
                    ) : advisoryBoard.length > 0 ? (
                        <div className="card">
                            <table className="data-table">
                                <thead>
                                    <tr className="table-header-row">
                                        <th className="szakinfo-title">Név</th>
                                        <th className="szakinfo-title">Cég neve</th>
                                        <th className="szakinfo-title">Beosztás</th>
                                        <th className="szakinfo-title">Elérhetőség</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {advisoryBoard.map((member, index) => (
                                        <tr key={member.id || index}>
                                            <td className="szakinfo-content">{member.nev}</td>
                                            <td className="szakinfo-content">{member.ceg_nev}</td>
                                            <td className="szakinfo-content">{member.beosztas}</td>
                                            <td className="szakinfo-content">{member.elerhetoseg}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="card">
                            <p>Ehhez a képzéshez még nem tartoznak tanácsadó testület tagok.</p>
                        </div>
                    )}
                </div>
            )}

            {!isLoading && !error && alapadatok && (
                <div className="uj-szak-container szakinfo-container-spaced">
                    <div className="section-header-container">
                        <h1 className="section-header-inline">Belső véleményezők</h1>
                        <button 
                            className="szak-button add-reviewer-button"
                            onClick={handleShowAddReviewerModal}
                        >
                            + Belső véleményező hozzáadása
                        </button>
                    </div>
                    
                    {belsoVelemenyezokLoading ? (
                        <p>Belső véleményezők adatainak betöltése...</p>
                    ) : assignedBelsoVelemenyezok.length > 0 ? (
                        <div className="card">
                            <table className="data-table">
                                <thead>
                                    <tr className="table-header-row">
                                        <th className="szakinfo-title">Név</th>
                                        <th className="szakinfo-title">Neptun kód</th>
                                        <th className="szakinfo-title">Szervezeti egység neve</th>
                                        <th className="szakinfo-title">Szervezeti egység kódja</th>
                                        <th className="szakinfo-title">Beosztás</th>
                                        <th className="szakinfo-title">Elérhetőség</th>
                                        <th className="szakinfo-title">Hozzáadva</th>
                                        <th className="szakinfo-title">Módosító neve</th>
                                        <th className="szakinfo-title"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {assignedBelsoVelemenyezok.map((reviewer, index) => (
                                        <tr key={reviewer.nk || index}>
                                            <td className="szakinfo-content">{reviewer.nev}</td>
                                            <td className="szakinfo-content">{reviewer.nk}</td>
                                            <td className="szakinfo-content">{reviewer.szerv_egyseg_neve}</td>
                                            <td className="szakinfo-content">{reviewer.szerv_egyseg_kodja}</td>
                                            <td className="szakinfo-content">{reviewer.beosztas}</td>
                                            <td className="szakinfo-content">{reviewer.elerhetoseg}</td>
                                            <td className="szakinfo-content">
                                                {new Date(reviewer.modositas_datuma).toLocaleDateString("hu-HU")}
                                            </td>
                                            <td className="szakinfo-content">{reviewer.modosito_neve}</td>
                                            <td className="action-cell">
                                                <button 
                                                    onClick={() => handleRemoveReviewer(reviewer)} className="remove-button">
                                                    Eltávolítás
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div className="card">
                            <p>Ehhez a képzéshez még nem tartoznak belső véleményezők.</p>
                        </div>
                    )}
                </div>
            )}

            {showReviewerModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
                            <button className="close-button"
                                onClick={() => setShowReviewerModal(false)}
                            >
                                Bezárás
                            </button>
                        </div>
                        
                        <div className="modal-search-container">
                            <input
                                type="text"
                                placeholder="Keresés név alapján..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="modal-search-input"
                            />
                        </div>
                        
                        <div className="dropdown-container">
                            {filteredReviewers.length > 0 ? (
                                filteredReviewers.map((reviewer, index) => (
                                    <div
                                        key={reviewer.nk || index}
                                        className="dropdown-item"
                                        onMouseEnter={(e) => e.target.closest('div').style.backgroundColor = '#f8f9fa'}
                                        onMouseLeave={(e) => e.target.closest('div').style.backgroundColor = 'white'}
                                        onClick={() => handleAddReviewer(reviewer)}
                                    >
                                        <div>
                                            <div className="dropdown-item-name">
                                                {reviewer.nev}
                                            </div>
                                            <div className="dropdown-item-nk">
                                                NK: {reviewer.nk}
                                            </div>
                                        </div>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleAddReviewer(reviewer);
                                            }}
                                            className="add-button"
                                        >
                                            Hozzáadás
                                        </button>
                                    </div>
                                ))
                            ) : (
                                <div className="dropdown-empty">
                                    {searchTerm ? 'Nincs találat a keresésre' : 'Nincsenek elérhető véleményezők'}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showRemoveModal && reviewerToRemove && (
                <div className="modal-overlay">
                    <div className="modal-content-small">
                        <h3 className="modal-title-warning">
                            Belső véleményező eltávolítása
                        </h3>
                        <p className="modal-text">
                            Biztosan eltávolítja <strong>{reviewerToRemove.nev}</strong> belső véleményezőt?
                        </p>
                        <div className="modal-button-container">
                            <button 
                                onClick={() => {
                                    setShowRemoveModal(false);
                                    setReviewerToRemove(null);
                                }}
                                className="cancel-button"
                            >
                                Mégse
                            </button>
                            <button 
                                onClick={confirmRemoveReviewer}
                                className="confirm-remove-button"
                            >
                                Eltávolítás
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SzakInformacio;
